import axios from 'axios'

import api from '@/services/base.service'

const methods = {
  addDisponibilidadByUsuario(usuario, parametros) {
    return api.post(`/usuarios/${usuario}/disponibilidad`, parametros)
  },
  cancelarDisponibilidad(disponibilidad) {
    return api.delete(`/disponibilidades/${disponibilidad}`)
  },
  getDisponibilidadByUsuario(usuario) {
    return api.get(`/usuarios/${usuario}/disponibilidad`)
  },
  getZonaByUsuario(usuario) {
    return api.get(`/usuarios/${usuario}/zonas`)
  },
  async getInfoByUsuario(usuario, callback) {
    let response = null
    let error = null
    await axios
      .all([
        this.getZonaByUsuario(usuario),
        this.getDisponibilidadByUsuario(usuario)
      ])
      .then(
        axios.spread((zonaResponse, disponibilidadResponse) => {
          response = {
            zonas: zonaResponse.data,
            disponibilidades: disponibilidadResponse.data
          }
        })
      )
      .catch((err) => {
        error = err
      })
    callback(error, response)
  },
  getUsuarios(bodegaId = -1) {
    return api.get(`/usuarios?bodegaId=${bodegaId}`)
  },
  getRoles() {
    return api.get(`/usuarios/roles`)
  },
  getUsuario(id) {
    return api.get(`/usuarios/${id}`)
  },
  getUsuarioBodega(id, bodegaId) {
    return api.get(`/usuarios/${id}/bodega/${bodegaId}`)
  },
  addUsuario(usuario) {
    return api.post(`/usuarios`, usuario)
  },
  updateUsuario(id, usuario) {
    return api.put(`/usuarios/${id}`, usuario)
  },
  deleteUsuario(id, bodegaId = -1) {
    return api.delete(`/usuarios/${id}?bodegaId=${bodegaId}`)
  }
}

export default methods
